import firebase from 'firebase'
import 'firebase/firestore'

const config = {
    apiKey: 'AIzaSyBwe9sonuhPLUuD7RTDMKVdpOoM_X0BZSs',
    authDomain: 'recipe-app-475a9.firebaseapp.com',
    databaseURL: 'https://recipe-app-475a9.firebaseio.com',
    projectId: 'recipe-app-475a9',
    storageBucket: 'recipe-app-475a9.appspot.com',
    messagingSenderId: '21829591397',
}

firebase.initializeApp(config)

const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

const recipesCollection = db.collection('recipes')
const sectionsCollection = db.collection('sections')
const ingredientsCollection = db.collection('ingredients')
const directionsCollection = db.collection('directions')
const usersCollection = db.collection('users')

export {
    db,
    auth,
    currentUser,
    recipesCollection,
    sectionsCollection,
    ingredientsCollection,
    directionsCollection,
    usersCollection,
}